import React from "react";  
import { inject, observer } from "mobx-react";
import ServiceStore from "../ServiceStore";
import { MembershipOptionWrapper, SetupDetails } from "../../../shared/styles";
import { ItemHeader, MembershipRelatedItems, UsageSection } from "../../../shared/components";
import { CountryWithStateModel, ServiceAndMembershipOptionsPageModel } from "../../../shared/models";
import { PricingPageService, RelatedItemsService } from "../../../shared/services";

type Props = {
  serviceStore?: ServiceStore;
  serviceId?: string | null;
  countriesWithState: CountryWithStateModel[];
};
@inject('serviceStore')
@observer
class OptionsPage extends React.Component<Props> {
  render(): React.ReactNode {
      return (
          <SetupDetails>
              <MembershipOptionWrapper>
                  <ItemHeader header="Service Options" />
                  {/*Hide due to requirements*/}
                  {false && (
                      <UsageSection
                          updateOptionsPage={(optionsPage: ServiceAndMembershipOptionsPageModel) =>
                              this.props.serviceStore?.updateOptionsPage(optionsPage)
                          }
                          toggleAddBenefitModal={() => this.props.serviceStore?.toggleAddBenefitModal()}
                          optionsPage={
                              this.props.serviceStore?.optionsPage || new ServiceAndMembershipOptionsPageModel()
                          }
                          showAddBenefitModal={this.props.serviceStore?.showAddBenefitModal === true}
                          pricingPageData={this.props.serviceStore?.pricingPageData || new PricingPageService()}
                      />
                  )}
                  <MembershipRelatedItems
                      sourceId={this.props.serviceId || ''}
                      realtedItemService={this.props.serviceStore?.realtedItemService || new RelatedItemsService()}
                      countriesWithState={this.props.countriesWithState || []}
                  />
              </MembershipOptionWrapper>
          </SetupDetails>
      );
  }
}

export default OptionsPage;
